import ControlsPage from 'src/sections/admin/controls/controls-page';

export default function Controls() {
  return <ControlsPage />;
}
